module.exports = __webpack_public_path__ + "ff13c502555d7f0cca07e331d6a74b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-10.png
// module id = 305
// module chunks = 1